import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatarGroup = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_18896_4524)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M2.43202 12.5854C3.82968 11.6493 5.49662 11.3736 7.05311 11.7573C7.42011 11.8478 7.60427 11.893 7.6205 12.022C7.63661 12.1509 7.45707 12.2471 7.09901 12.439C6.82743 12.5845 6.56121 12.737 6.36561 12.8579C5.89765 13.1315 5.01601 13.6472 4.37929 14.2944C3.96847 14.7121 3.42815 15.4061 3.32753 16.3608C3.29649 16.6557 3.31095 16.9384 3.36171 17.2065C3.41255 17.475 3.43745 17.6097 3.36952 17.6802C3.30156 17.7502 3.18835 17.7331 2.96229 17.6987C1.99385 17.5513 1.33927 17.0234 0.802138 16.4478C0.400541 16.0173 0.193186 15.5221 0.244521 14.9927C0.292832 14.4955 0.558767 14.095 0.824599 13.8022C1.24418 13.3402 1.86243 12.9479 2.2328 12.7134C2.31182 12.6634 2.37996 12.6203 2.43202 12.5854ZM5.67714 4.96729C5.83373 4.9673 5.98778 4.97886 6.13808 5.00146C6.31742 5.02844 6.40742 5.04217 6.45351 5.1167C6.49929 5.1912 6.46686 5.29016 6.40272 5.48779C6.23841 5.99411 6.14979 6.53511 6.14979 7.09619C6.14989 8.26897 6.53807 9.35104 7.19276 10.2212C7.31771 10.3872 7.37998 10.4707 7.36073 10.5562C7.34144 10.6415 7.26154 10.684 7.10097 10.7681C6.67532 10.9909 6.19087 11.1166 5.67714 11.1167C3.97894 11.1167 2.60194 9.7397 2.60194 8.0415C2.60213 6.34347 3.97906 4.96729 5.67714 4.96729Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M15.6543 11.7573C17.2108 11.3736 18.8778 11.6493 20.2754 12.5854C20.3275 12.6203 20.3956 12.6633 20.4746 12.7134C20.845 12.9479 21.4633 13.3402 21.8828 13.8022C22.1487 14.095 22.4146 14.4955 22.4629 14.9927C22.5142 15.5221 22.3069 16.0173 21.9053 16.4478C21.3682 17.0234 20.7136 17.5513 19.7451 17.6987C19.5188 17.7332 19.4049 17.7506 19.3369 17.6802C19.2692 17.6097 19.2949 17.4748 19.3457 17.2065C19.3965 16.9384 19.4109 16.6557 19.3799 16.3608C19.2793 15.4061 18.739 14.7121 18.3281 14.2944C17.6914 13.6472 16.8098 13.1315 16.3418 12.8579C16.1462 12.737 15.88 12.5845 15.6084 12.439C15.2504 12.2471 15.0708 12.1509 15.0869 12.022C15.1032 11.893 15.2873 11.8478 15.6543 11.7573ZM17.0303 4.96729C18.7284 4.96729 20.1053 6.34347 20.1055 8.0415C20.1055 9.7397 18.7285 11.1167 17.0303 11.1167C16.5166 11.1167 16.0321 10.9909 15.6065 10.7681C15.4458 10.684 15.365 10.6416 15.3457 10.5562C15.3265 10.4708 15.3898 10.3872 15.5147 10.2212C16.1693 9.35105 16.5575 8.26895 16.5576 7.09619C16.5576 6.53511 16.469 5.99411 16.3047 5.48779C16.2405 5.29009 16.2081 5.19121 16.2539 5.1167C16.3 5.04216 16.3899 5.02845 16.5694 5.00146C16.7197 4.97886 16.8737 4.9673 17.0303 4.96729Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.27719 13.6933C9.77281 12.1501 12.9382 12.1501 15.4338 13.6933C15.5074 13.7387 15.6006 13.7933 15.7077 13.8559C16.1924 14.1395 16.9617 14.5897 17.4867 15.1234C17.8165 15.4585 18.1453 15.9155 18.2053 16.4851C18.2694 17.0945 18.0108 17.6587 17.5173 18.1469C16.7021 18.9534 15.6923 19.6317 14.3683 19.6317H8.34275C7.01872 19.6317 6.00891 18.9534 5.19372 18.1469C4.70026 17.6587 4.44159 17.0945 4.50574 16.4851C4.5657 15.9155 4.89457 15.4585 5.22431 15.1234C5.74931 14.5897 6.51867 14.1395 7.00333 13.8559C7.11042 13.7933 7.20361 13.7388 7.27719 13.6933Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.33447 7.09566C7.33447 4.87495 9.13472 3.07471 11.3554 3.07471C13.5761 3.07471 15.3764 4.87495 15.3764 7.09566C15.3764 9.31638 13.5761 11.1166 11.3554 11.1166C9.13472 11.1166 7.33447 9.31638 7.33447 7.09566Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_18896_4524",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 22.7066,
				height: 22.7066,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgAvatarGroup);
export default ForwardRef;
